// Orders
export const orderCustomerName = (order) =>
  order.customer
    ? `${order.customer.first_name || ""} ${order.customer.last_name}`
    : "";
export const orderTitle = (order) =>
  `Order ${order.name} for ${orderCustomerName(order)}`;

export const getWeekday = (weekday) => {
  const weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  return weekdays[weekday];
};

export const getMonth = (index) => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return months[index];
};

export const orderShippingMethod = (order) => {
  const METHOD_KEY = "Method";
  const methodNote = order.note_attributes.filter(
    (x) => x.name === METHOD_KEY
  )[0];
  if (methodNote) {
    return methodNote.value;
  }
  if (order.service && order.service.type) {
    return order.service.type;
  }

  // No Method attr and no service.type (SAN-5): infer from the shipping line.
  // Shopify local pickup lines have source "shopify" and the location name as
  // the title; delivery lines say "Delivery" or come from our carrier service.
  const line = order.shipping_lines && order.shipping_lines[0];
  const title = (line && line.title) || "";
  if (/deliver|ship/i.test(title) || /grocer ?box/i.test((line && line.source) || "")) {
    return "delivery";
  }
  if (title && line.source === "shopify") {
    return "pickup";
  }

  return order.service ? order.service.type : "manual";
};

export const parseOrderData = (order) => {
  const DATE_KEY = "Date";
  const PICKUP_TIME_KEY = "Pickup Time";

  // For special pickup times
  let pickupTime = order.note_attributes?.filter(
    (x) => x.name === PICKUP_TIME_KEY
  )[0];
  pickupTime = pickupTime ? pickupTime.value : null;

  // Get data from service and fallback to note attributes
  let date = order.service?.date;
  if (!date) {
    const dateNote = order.note_attributes?.filter(
      (x) => x.name === DATE_KEY
    )[0];
    date = dateNote ? dateNote.value : null;
  }

  if (!date || date === "" || date === "0") {
    return {
      collectionDate: null,
      date: null,
      year: null,
      month: null,
      day: null,
      hour: null,
      pickupTime,
    };
  }

  // Parse the date string (format: YYYY-MM-DD)
  const [year, month, day] = date.split("-").map(Number);

  // Validate the date components
  if (!year || !month || !day || isNaN(year) || isNaN(month) || isNaN(day)) {
    return {
      collectionDate: null,
      date: null,
      year: null,
      month: null,
      day: null,
      hour: null,
      pickupTime,
    };
  }

  // Derive hour from service or fallback to window code in notes/shipping lines
  let hour = order.service?.hour;
  if (hour == null) {
    try {
      const codeNote = order.note_attributes?.find((n) => n.name === "code");
      const code = codeNote?.value || order.shipping_lines?.[0]?.code;
      if (code) {
        const delim = code.includes("|") ? "|" : ".";
        const parts = code.split(delim);
        const parsed = parseInt(parts[parts.length - 1], 10);
        if (!Number.isNaN(parsed)) hour = parsed;
      }
    } catch (_) {}
  }
  let collectionDate = new Date(year, month - 1, day);

  // Validate the date object
  if (isNaN(collectionDate.getTime())) {
    return {
      collectionDate: null,
      date: null,
      year: null,
      month: null,
      day: null,
      hour: null,
      pickupTime,
    };
  }

  if (hour) {
    collectionDate.setHours(parseInt(hour, 10) || 0);
  }

  return { collectionDate, date, year, month, day, hour, pickupTime };
};

export const noteKeys = {
  pickupLocation: "Pickup Location",
};

export const orderNote = (order, name) => {
  const note = order.note_attributes.filter(
    (n) => n.name.toLowerCase() === name.toLowerCase()
  )[0];
  return note ? note.value : null;
};

export function validEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function deepEqual(object1, object2) {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  /* eslint-disable-next-line no-unused-vars */
  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if (
      (areObjects && !deepEqual(val1, val2)) ||
      (!areObjects && val1 !== val2)
    ) {
      return false;
    }
  }
  return true;
}

export function isObject(object) {
  return object != null && typeof object === "object";
}
